export const STATIC_VIEW = process.env.BASE_API + '/static_view/'
export const STATIC_DOWNLOAD = process.env.BASE_API + '/static_download/'
export const H5_INDEX = '/H5/v_indexMobile.htm'
// 材料缩略图
export const MATERIAL_VIEW_SIMPLE = process.env.BASE_API + '/auth/material/view?viewType=0'
// 材料原图
export const MATERIAL_VIEW_FULL = process.env.BASE_API + '/auth/material/view?viewType=1'



// WEBPACK FOOTER //
// ./src/api/static_api.js